import React from 'react';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Typography,
  Divider,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../hooks/useAuth';
import { NavigationProps } from '../layout.types';

export const Navigation: React.FC<NavigationProps> = ({
  items,
  onNavigate,
  currentPath,
  isItemVisible,
}) => {
  const { t } = useTranslation();

  return (
    <List>
      {items
        .filter(isItemVisible)
        .map((item) => (
          <ListItem key={item.key} disablePadding>
            <ListItemButton
              selected={currentPath === item.path}
              onClick={() => onNavigate(item.path)}
            >
              <ListItemIcon>
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={t(`navigation.${item.key}`)} />
            </ListItemButton>
          </ListItem>
        ))}
    </List>
  );
};

interface AdminNavigationProps {
  items: NavigationProps['items'];
  onNavigate: NavigationProps['onNavigate'];
  currentPath: NavigationProps['currentPath'];
  isItemVisible: NavigationProps['isItemVisible'];
}

export const AdminNavigation: React.FC<AdminNavigationProps> = ({
  items,
  onNavigate,
  currentPath,
  isItemVisible,
}) => {
  const { user } = useAuth();

  if (user?.role !== 'admin') {
    return null;
  }

  return (
    <>
      <Divider />
      <List>
        <ListItem>
          <Typography variant="overline" color="text.secondary">
            管理者機能
          </Typography>
        </ListItem>
        {items
          .filter(isItemVisible)
          .map((item) => (
            <ListItem key={item.key} disablePadding>
              <ListItemButton
                selected={currentPath === item.path}
                onClick={() => onNavigate(item.path)}
              >
                <ListItemIcon>
                  {item.icon}
                </ListItemIcon>
                <ListItemText 
                  primary={
                    item.key === 'admin' ? '管理者ダッシュボード' :
                    `navigation.${item.key}`
                  } 
                />
              </ListItemButton>
            </ListItem>
          ))}
      </List>
    </>
  );
};
